import { SEARCH_FAILED, SEARCH_LOADING, SEARCH_SUCCESS } from './constants';

const initialValue = {
  isLoading: false,
  message: '',
  data: {},
  success: false,
  code: null,
};

const initialState = {
  dataNikManagement: initialValue,
  updateNikStatus: initialValue,
  updateNikStatusBulk: initialValue,
  dataCheckStatusBulk: initialValue,
  listRequestStatusBulk: { ...initialValue, data: [] },
};

export default function reducer(state = initialState, action) {
  const { type, isLoading, message, data, code, key, status } = action;

  switch (type) {
    case SEARCH_SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          code,
          message,
          success: true,
          data,
          status,
          isLoading: false,
        },
      };
    case SEARCH_FAILED:
      return {
        ...state,
        [key]: {
          ...state[key],
          message,
          isLoading: false,
          success: false,
          status: status,
          data: data || null,
          code,
        },
      };
    case SEARCH_LOADING:
      return {
        ...state,
        [key]: {
          ...state[key],
          isLoading,
        },
      };
    default:
      return state;
  }
}
